import {useState} from "react";
import {Button, Image, Input, Radio, Toast} from "antd-mobile";
import {TOASTDURATION} from "../../common/Utils";
import {pixelCreate} from "../../common/ApiAction";

const Pixel = () => {

    const [payAmount, setPayAmount] = useState<string>('')
    const [destination, setDestination] = useState<string>('')
    const [channelType, setChannelType] = useState<string>('')
    const [customData, setCustomData] = useState<string>('')

    const sumbitAction = () => {
        if (!destination) {
            Toast.show({content: "Veuillez entrer le numéro", duration: TOASTDURATION})
            return
        }
        if (!payAmount) {
            Toast.show({content: "Veuillez entrer le montant", duration: TOASTDURATION})
            return
        }
        if (!channelType) {
            Toast.show({content: "Veuillez sélectionner le canal", duration: TOASTDURATION})
            return
        }
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        const data = {
            networkType: channelType,
            countryCode: 'cameroon',
            amount: payAmount.trim(),
            customData: customData.trim(),
            phoneNumber: destination.trim()
        }
        pixelCreate(data).then((res: any) => {
            Toast.clear();
            if (parseInt(res.code) !== 200 ) {
                Toast.show({icon: 'fail', content: res.message || res.msg, duration: TOASTDURATION})
            } else {
                // 清空输入框
                setDestination('')
                setPayAmount('')
                setChannelType('')
                setCustomData('')
                Toast.show({icon: 'success', content: "Order placed successfully, please complete the subsequent Payment!", duration: TOASTDURATION})
            }
        })
    }
    return (
        <div style={{width: '100%', display: "flex", flexDirection: "column", alignItems: "center"}}>
            <div>
                <Image src={require('../../assets/icon_ego_logo.jpg')} style={{width: 100}}/>
            </div>
            <div style={{borderRadius: 8, padding: '50px 0 20px 0', border: "solid #08ad58 1px", width: '90%', marginTop: 15, display: "flex", flexDirection: "column", alignItems: "center"}}>
                <span style={{fontSize: 20, fontWeight: "bold",marginBottom: 30}}>Centre de paiement</span>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "start", width: '100%'}}>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10}}>
                        <span style={{fontSize: 12, marginRight: 10, width: 80}}>Votre numéro:</span>
                        <Input value={destination} onChange={val => setDestination(val)} type={'number'} style={{"--font-size": '12px', width: '45%', border: "solid #cccccc 1px"}} placeholder={"numéro de téléphone"}/>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10}}>
                        <span style={{fontSize: 14, marginRight: 10, width: 80}}>Montant:</span>
                        <Input value={payAmount} onChange={val => setPayAmount(val)} type={'number'} style={{"--font-size": '10px', width: '45%', border: "solid #cccccc 1px"}} placeholder={"Montant"}/>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10}}>
                        <span style={{fontSize: 14, marginRight: 10, width: 80}}>Numéro Identifiant:</span>
                        <Input value={customData} onChange={val => setCustomData(val)} type={'text'} style={{"--font-size": '10px', width: '45%', border: "solid #cccccc 1px"}} placeholder={"CustomData"}/>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 10}}>
                        <span style={{fontSize: 14, marginRight: 10, width: 80}}>Channel:</span>
                        <Radio.Group value={channelType} onChange={val => setChannelType(val as string)}>
                            <Radio style={{'--font-size': '14px', '--gap': '6px','--icon-size': '15px'}} value="ORANGE">ORANGE</Radio>
                            <Radio style={{'--font-size': '14px', '--gap': '6px','--icon-size': '15px', marginLeft: 10}} value="MTN">MTN</Radio>
                        </Radio.Group>
                    </div>
                </div>
            </div>
            <div>
                <Button shape='rounded' style={{backgroundColor: '#08ad58', color: '#FFF', marginTop: 50, paddingLeft: 30, paddingRight: 30}} onClick={sumbitAction}>Confirmer et procéder</Button>
            </div>
        </div>
    )
}
export default Pixel
